import { getPreloadsFromPath } from './getPreloadsFromPath';

// for now, we want to get the initial preloads upon rendering and not on transition
const pathnameOnLoad = window?.location?.pathname;
const searchOnLoad = window?.location?.search;
const cookiesOnLoad = window?.document?.cookie;
export const getPreloadsFromInitialPath = (): ReturnType<
  typeof getPreloadsFromPath
> => getPreloadsFromPath(pathnameOnLoad, searchOnLoad, cookiesOnLoad);
